import React from 'react';
import PropertyCard from '../properties/PropertyCard';
import './FeaturedListings.scss'; // Assuming you have a separate SCSS file for styles

const FeaturedListings = ({ properties, onSelect }) => {
    return (
        <div className="featured-listings">
            <h2>Featured Listings</h2>
            <div className="property-list">
                {properties.map(property => (
                    <PropertyCard key={property.id} property={property} onSelect={onSelect} />
                ))}
            </div>
        </div>
    );
};

export default FeaturedListings;